/**
 * @file this component checks the authenticated state of the user and whether to route them
 * forward or not.
 */
import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import UserContext from '../contexts/userContext';

function PrivateRoute({ path, component: PropsComponent, routes, mode, setRefreshNotifications }) {
    const user = useContext(UserContext);
    if (user.account) {
        return (
            <Route
                path={path}
                render={(props) => (
                    // pass the sub-routes down to keep nesting
                    <PropsComponent
                        {...props}
                        routes={routes}
                        mode={mode}
                        setRefreshNotifications={setRefreshNotifications}
                    />
                )}
            />
        );
    }
    return <Redirect to={{ pathname: process.env.REACT_APP_LOGIN_URL }} />;
}

export default PrivateRoute;
